import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 13H5v-2h14v2z"
}), 'RemoveSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/RemoveSharp.js
// module id = 5731
// module chunks = 2